// 列表组件需要的数据
export const OPTHINES = {
  voteName: '2020project/2020bashu_exhibition',
  mustSearch: 'Button',
  number: {
    mustRank: true,
  },
  listData: {
    type: 'com',
  },
  themeColor: {
    activeBgColor: 'rgb(19, 86, 128)',
    inactiveBgColor: 'rgb(187, 211, 220)',
  },
  tabs: [
    {
      tabName: '进入展览',
      tabPath: '/20200703GKDBM/List',
    },
    {
      tabName: '活动背景',
      tabPath: '/20200703GKDBM/Rules',
    },
  ],
};
